module.exports = __webpack_public_path__ + "img/no_posts_image.5959798.svg";